import * as Html from "../../util/Html.ts";
import * as Redim from "../../lib/redim/imageRedim.ts";
import * as Medias from "../../server/Medias.ts";
import Icons from "../../svg/Icons.ts";

export {initDom}
Html.registerWidget('widget/form/input-images-simple',{initDom})

function smoothScrollTo(container,targetIdx :number){
  clearInterval(container.getAttribute('smoothScrollInterval'));

  let
    length = container.childNodes.length,
    idx = (targetIdx + 50*length) % length,
    scrollTarget = idx * container.offsetWidth,
    scrollBegin = container.scrollLeft,
    frame=0,
    subInterval = setInterval(function(){
      frame++;
      container.scrollTo(scrollBegin+(scrollTarget-scrollBegin)*frame/50,0);
      if(frame>=50){
        clearInterval(subInterval);
      }
    },10);
  container.setAttribute('smoothScrollInterval',subInterval)
}



function initDom(node: HTMLElement){
  var
    defaultAdd = Array.from(node.children) as HTMLElement[],
    currentIdx = 0,
    multiple = true,
    inputName = node.getAttribute('name')||'picture';

  node.style.height = node.offsetHeight + 'px';
  node.classList.add("input-image");

  node.insertAdjacentHTML('beforeend', '<icon class="picture-right">'+Icons.ic_chevron_right+'</icon>');
  node.insertAdjacentHTML('beforeend', '<icon class="picture-left">'+Icons.ic_chevron_left+'</icon>');
  node.insertAdjacentHTML('beforeend', '<icon class="picture-delete">'+Icons.ic_close+'</icon>');
  node.insertAdjacentHTML('beforeend', '<icon class="picture-reset">'+Icons.ic_repeat+'</icon>');

  node.insertAdjacentHTML('beforeend', '<ib class="picture-add">'+Icons.ic_camera+'</ib>');
  node.insertAdjacentHTML('beforeend', '<span style="display:inline-block;width:100%;height:100%;overflow:hidden;white-space:nowrap;font-size:0"></span>');
  node.insertAdjacentHTML('beforeend', '<input type="file" accept="image/*" style="display:none" multiple>');
  node.insertAdjacentHTML('beforeend', '<input type="hidden" name="'+inputName+'" value="$empty">');

  var
    addTag = node.querySelector('.picture-add') as HTMLElement,
    nextTag = node.querySelector('.picture-right') as HTMLElement,
    prevTag = node.querySelector('.picture-left') as HTMLElement,
    deleteTag = node.querySelector('.picture-delete') as HTMLElement,
    imgContainer = node.querySelector('span') as HTMLElement,
    inputFileAdd = node.querySelector('input[type="file"]') as HTMLInputElement,
    inputEmpty = node.querySelector('input[type="hidden"]') as HTMLInputElement,
    originalValues = (node.getAttribute("data-value") || '').split(' ').filter(t=>t.length>0);

  function append(value){
    const html = '<span style="display:inline-block;width:100%;height:100%;transition:all linear 0.3s">'
      +'<img src="'+value.preview+'"/>'
      +'<input type="hidden" name="'+inputName+'" value="'+value.url+'">'
      +'</span>';
    imgContainer.insertAdjacentHTML('beforeend', html);
    value.node = imgContainer.children[imgContainer.children.length - 1] as HTMLElement;
    const inputEl = value.node.querySelector('input') as HTMLInputElement;
    inputEl.value = value.url;
    (inputEl as any).file = value.file;
    const imgEl = value.node.querySelector('img');
    if(imgEl) {
      imgEl.onerror = function(){
        deleteTag.click()
      }
    }
  }

  originalValues.forEach(function(url,idx){
    let
      isInternal = url.indexOf('/media/')>-1,
      hasQuery = url.indexOf('?')>-1;
    append({
      url:url,
      preview:isInternal?(url+(hasQuery?'&':'?')+"w=512&h=512&s=r"):url,
    })
  });

  function majUI(){
    var
      length = imgContainer.children.length,
      hasImg = length>0;
    defaultAdd.forEach(el => el.style.display = hasImg ? 'none' : '');

    imgContainer.style.display = hasImg ? '' : 'none';
    prevTag.style.display = (hasImg && currentIdx>0) ? '' : 'none';
    nextTag.style.display = (hasImg && currentIdx<length-1) ? '' : 'none';
    deleteTag.style.display = hasImg ? '' : 'none';
    addTag.style.display = hasImg ? '' : 'none';
    inputEmpty.disabled = hasImg;
  }
  majUI();
  nextTag.addEventListener("click",function(e){
    e.stopPropagation();
    e.preventDefault();
    var length = imgContainer.children.length;
    currentIdx = (currentIdx+1)%length;
    smoothScrollTo(imgContainer,currentIdx);
    majUI();
  });
  prevTag.addEventListener("click",function(e){
    e.stopPropagation();
    e.preventDefault();
    var length = imgContainer.children.length;
    currentIdx = (currentIdx-1+length)%length;
    smoothScrollTo(imgContainer,currentIdx);
    majUI();
  });
  deleteTag.addEventListener("click",function(e){
    e.stopPropagation();
    e.preventDefault();
    let theNodeToRemove = imgContainer.querySelectorAll('span')[currentIdx] as HTMLElement;
    theNodeToRemove.style.width="0";
    setTimeout(function(){
      theNodeToRemove.remove();
      var length = imgContainer.children.length;
      if(currentIdx>=length){
        currentIdx--;
      }
      if(currentIdx<=0){
        currentIdx=0;
      }

      majUI();
    },300)

  });
  addTag.addEventListener("click",function(e){
    multiple = true;
    inputFileAdd.setAttribute('multiple','multiple')
  });
  imgContainer.addEventListener("click",function(e){
    multiple = false;
    inputFileAdd.removeAttribute('multiple')
  });

  inputFileAdd.addEventListener('change',async function(){
    if(!await Medias.checkQuota()) return;
    let i=0;
    if(!multiple && this.files){
      let currentNode = imgContainer.querySelectorAll('span')[currentIdx] as HTMLElement;
      const inputEl = currentNode.querySelector('input') as any;
      inputEl.file = this.files[i];
      const dataurl = await Redim.thumbnail(this.files[i],{width:node.offsetWidth,height:node.offsetHeight})
      const imgEl = currentNode.querySelector('img') as HTMLImageElement;
      imgEl.src = dataurl;
      i++;
    }
    if(this.files){
      for(;i<this.files.length;i++){
        const file = this.files[i];
        const dataurl = await Redim.thumbnail(file,{width:node.offsetWidth,height:node.offsetHeight})

        append({
          preview:dataurl,
          file:file
        });
        //on va au dernier
        currentIdx = imgContainer.children.length-1;
        smoothScrollTo(imgContainer,currentIdx);

        majUI();

      }
    }

  });

}
